import { render, staticRenderFns } from "./StepNeeds.vue?vue&type=template&id=5a7084fe&scoped=true&"
import script from "./StepNeeds.vue?vue&type=script&lang=js&"
export * from "./StepNeeds.vue?vue&type=script&lang=js&"
import style0 from "./StepNeeds.vue?vue&type=style&index=0&id=5a7084fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7084fe",
  null
  
)

export default component.exports